<template>
  <td class="smsc-table__cell">
    <slot />
  </td>
</template>

<script>
export default {
  name: 'smsc-td'
}
</script>